import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitch = () => {
    const { i18n } = useTranslation();
    const current = i18n.language;

    const toggle = () => {
        const next = current === 'it' ? 'en' : 'it';
        i18n.changeLanguage(next);
        localStorage.setItem('lang', next);
    };

    const isIT = current === 'it';

    return (
        <div className="flex items-center gap-1 font-mono text-xs">
            <span className={isIT ? 'text-amber-600 dark:text-amber-400' : 'text-zinc-400 dark:text-zinc-500 hover:text-zinc-700 dark:hover:text-zinc-300 transition-colors cursor-pointer'} onClick={isIT ? undefined : toggle}>IT</span>
            <span className="text-zinc-300 dark:text-zinc-600">/</span>
            <span className={!isIT ? 'text-amber-600 dark:text-amber-400' : 'text-zinc-400 dark:text-zinc-500 hover:text-zinc-700 dark:hover:text-zinc-300 transition-colors cursor-pointer'} onClick={!isIT ? undefined : toggle}>EN</span>
        </div>
    );
};

export default LanguageSwitch;
